import React from 'react'
import Kpiresponsedownloadfile from '../../components/kpiresponsereportcomponent/Kpiresposedownloadfile'

function  Kpiresponsedownload({renderPageContent}) {
    return (
        <>
                        <Kpiresponsedownloadfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Kpiresponsedownload